export default "__VITE_ASSET__f3440336__"